import { membershipProductEvaluationHandler } from './membershipProductEvaluation';
export const evaluateMembershipProductActions = {
  evaluate: membershipProductEvaluationHandler.evaluate
};